import classNames from 'classnames';
import { ComponentType, GetPageComponentItemViewModel } from '@/types/cml-api';
import { AppNextLink } from '@/features/app-next-link';
import { IconArrowLeft } from '@/features/icons';
import LazyImage from '@/features/image/lazy-image';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { useDataLayerPush } from '@/app/_utils/use-datalayer-push';
import { DataLayerProps, IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps, GetPageComponentItemViewModel, DataLayerProps {}
export default function TestimonialItem({
  id,
  isLazy,
  index,
  brandDesktopImageUrl,
  brandMobileImageUrl,
  desktopImageUrl,
  link,
  mobileImageUrl,
  text,
  title,
  currentSlide,
  componentId,
  sortKey
}: Props) {
  const isActiveItem = currentSlide === Number(index) - 1;
  const {
    isMobile
  } = useMobileDetect();
  const pushToDataLayer = useDataLayerPush();
  const handleClick = () => {
    pushToDataLayer({
      event: 'cta_click',
      componentId,
      elementType: ComponentType.Testimonial,
      elementName: sortKey,
      itemID: id || '',
      elementIndex: index || 0,
      destinationUrl: link || '',
      ImageUrl: isMobile ? mobileImageUrl : desktopImageUrl
    });
    Webengage.trackCtaAction({
      component_id: componentId ?? '',
      banner_type: ComponentType.Testimonial,
      banner_name: sortKey ?? '',
      item_id: id || '',
      banner_index: index?.toString() || '0',
      url_destination: link || '',
      image_url: (isMobile ? mobileImageUrl : desktopImageUrl) ?? ''
    });
  };
  if (!mobileImageUrl || !title) return null;
  return <AppNextLink href={link || ''} prefetch={false} className='keen-slider__slide' onClick={handleClick} data-sentry-element="AppNextLink" data-sentry-component="TestimonialItem" data-sentry-source-file="testimonial-item.tsx">
            <div className={classNames('transform-gpu overflow-hidden rounded-lg border border-border-gray-light bg-white p-2 transition-transform duration-200 lg:min-h-[200px] lg:p-3', isMobile && (isActiveItem ? 'scale-y-100' : 'scale-y-90'))}>
                <div className='flex h-[36px] items-center justify-between'>
                    <p className={classNames('text-caption-12 font-medium text-text-darkGray lg:text-body-16')}>
                        <span className='text-primary-main'>به خاطر خودت</span>،‌ چون{' '}
                        <span className='text-primary-main'>نظرت</span> مهمه...
                    </p>
                    <picture data-sentry-element="picture" data-sentry-source-file="testimonial-item.tsx">
                        <source media='(min-height: 36px)' srcSet={brandDesktopImageUrl || ''} />
                        <img src={brandMobileImageUrl ?? ''} alt={title} className='max-h-[36px] w-full object-contain' loading={isLazy ? 'lazy' : undefined} />
                    </picture>
                </div>
                <div className='mt-2 flex items-start gap-1'>
                    <picture data-sentry-element="picture" data-sentry-source-file="testimonial-item.tsx">
                        <source media='(min-height: 84px)' srcSet={desktopImageUrl || ''} />

                        <LazyImage src={mobileImageUrl} alt={title} className='h-[84px] min-w-[84px] lg:h-[112px] lg:min-w-[112px]' loaderClassName='h-[84px] lg:h-[112px] w-[84px] lg:w-[112px]' isLazy={isLazy} data-sentry-element="LazyImage" data-sentry-source-file="testimonial-item.tsx" />
                    </picture>

                    <div>
                        <div className='flex items-center'>
                            <span className={classNames('ml-2 line-clamp-1 text-caption-12 font-medium text-text-darkGray lg:text-body-16')}>
                                {title}
                            </span>
                            <div className='min-w-5'>
                                <IconArrowLeft fontSize={isMobile ? 10 : 13} data-sentry-element="IconArrowLeft" data-sentry-source-file="testimonial-item.tsx" />
                            </div>
                        </div>
                        <p className={classNames('lg:text-body-1 mt-1 line-clamp-3 text-caption-12 font-medium lg:mt-3 lg:text-body-16 lg:leading-7')}>
                            {text}
                        </p>
                    </div>
                </div>
            </div>
        </AppNextLink>;
}